let _pdfjsPromise = null;

async function loadPdfJsFromPublic() {
  if (_pdfjsPromise) return _pdfjsPromise;

  // Do not remove the comment about webpack below.  It will cause pipeline error.
  _pdfjsPromise = import(
    /* webpackIgnore: true */
    "/pdfjs/build/pdf.mjs"
  );

  return _pdfjsPromise;
}

export async function getPdfDimensionsInInches(urlPdfFile) {
  const pdfjsLib = await loadPdfJsFromPublic();

  pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdfjs/build/pdf.worker.mjs";

  console.log("PDFJS workerSrc =", pdfjsLib.GlobalWorkerOptions.workerSrc);

  const loadingTask = pdfjsLib.getDocument(urlPdfFile);

    try {
        const pdf = await loadingTask.promise;
        const page = await pdf.getPage(1);
        const viewport = page.getViewport({
            scale: 1,
            rotation: page.rotate, // explicitly respect PDF rotation (i.e. if the page is landscape)
        });

        const widthPts = viewport.width;
        const heightPts = viewport.height;

        const widthInches = widthPts / 72;
        const heightInches = heightPts / 72;

        return {
            widthInches,
            heightInches,
        };
    }  finally {
        // stop any in-flight network work + free internal resources
        //try { loadingTask?.destroy?.(); } catch {}
    }
}